import { createProjectPortfolioError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditProjectPortfolioRequestFailure(portfolio) {
      const req = getState().find(
        (req) => req.portfolio.uuid === portfolio.uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isEditProjectPortfolioRequestPending(portfolio) {
      const req = getState().find(
        (req) => req.portfolio.uuid === portfolio.uuid,
      );

      return req ? req.request.isPending : false;
    },
    isEditProjectPortfolioRequestSuccess(portfolio) {
      const req = getState().find(
        (req) => req.portfolio.uuid === portfolio.uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
    getEditProjectPortfolioError(portfolio) {
      const req = getState().find(
        (req) => req.portfolio.uuid === portfolio.uuid,
      );

      return req ? req.error : createProjectPortfolioError;
    },
  };
}

export { createSelector };
